import { memo, useState } from 'react';
import { roundBook, fmtBook } from '../../utils/casinoBook';
import Collapse from '../Collapse';

function findBySid(sub, sid) {
  return sub.find((s) => s.sid === sid);
}

function isSusp(item) {
  return !item || item.gstatus === 'SUSPENDED' || item.gstatus === '0' || item.b === 0;
}

function suspCls(item) {
  return isSusp(item) ? ' suspended' : '';
}

function fmtAmt(n) {
  const x = Number(n) || 0;
  if (x >= 100000) return `${x / 100000}L`;
  if (x >= 1000) return `${x / 1000}K`;
  return String(x);
}

function bookOf(exposures, name, sid) {
  return roundBook(exposures?.[`sid:${sid}`] ?? exposures?.[name] ?? 0);
}

function bookCls(v) {
  return v < 0 ? 'book-red' : v > 0 ? 'book-green' : 'book-black';
}

// ─── Desktop layout (d-none-small) ───────────────────────────────────────────

// reference: book hamesha visible (book-black at 0) + info-circle collapse
// toggle jo min-max range dikhata hai. Main rows me `mr-2 casino-book`, uo
// rows me plain `book-black` span.
function RangeInfo({ book, rangeId, min, max, plain }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="float-right">
      <span className={plain ? bookCls(book) : `mr-2 casino-book ${bookCls(book)}`}>{fmtBook(book)}</span>
      {' '}
      <i
        data-toggle="collapse"
        data-target={`#${rangeId}`}
        aria-expanded={open ? 'true' : 'false'}
        className={`fas fa-info-circle${open ? '' : ' collapsed'}`}
        onClick={() => setOpen((o) => !o)}
      ></i>
      {' '}
      <Collapse id={rangeId} open={open} className="icon-range">
        {'\n                          R:'}
        <span>{fmtAmt(min)}</span>
        -
        <span>{fmtAmt(max)}</span>
      </Collapse>
    </div>
  );
}

const DesktopLayout = memo(function DesktopLayout({ sub, onBet, exposures }) {
  const playerA = findBySid(sub, 1);
  const playerB = findBySid(sub, 2);
  const under21 = findBySid(sub, 3);
  const over21  = findBySid(sub, 4);

  return (
    <div className="teen1daycasino-container d-none-small">
      {/* LEFT: Player A */}
      <div className="teen1dayleft">
        <div className="casino-box-row">
          <div className="casino-nation-name no-border casino-bl-box-title">
            <div className="playera">Player A</div>
          </div>
          <div className="casino-bl-box casino-bl-box-title">
            <div className="casino-bl-box-item"><b>Back</b></div>
            <div className="casino-bl-box-item"><b>Lay</b></div>
          </div>
        </div>
        <div className="casino-box-row">
          <div className="casino-nation-name">
            <b>Main</b>
            <RangeInfo book={bookOf(exposures, 'Player A', 1)} rangeId="range1" min={playerA?.min} max={playerA?.max} />
          </div>
          <div className="casino-bl-box">
            <div
              className={`back casino-bl-box-item${suspCls(playerA)}`}
              onClick={isSusp(playerA) ? undefined : () => onBet(playerA.sid, 'back', playerA.b, playerA)}
            >
              <span className="casino-box-odd">{playerA?.b || 0}</span>
            </div>
            <div
              className={`lay casino-bl-box-item${suspCls(playerA)}`}
              onClick={isSusp(playerA) ? undefined : () => onBet(playerA.sid, 'lay', playerA.l, playerA)}
            >
              <span className="casino-box-odd">{playerA?.l || 0}</span>
            </div>
          </div>
        </div>
      </div>

      {/* CENTER divider */}
      <div className="teen1daycenter"></div>

      {/* RIGHT: Player B */}
      <div className="teen1dayright">
        <div className="casino-box-row">
          <div className="casino-nation-name no-border casino-bl-box-title">
            <div className="playerb">Player B</div>
          </div>
          <div className="casino-bl-box casino-bl-box-title">
            <div className="casino-bl-box-item"><b>Back</b></div>
            <div className="casino-bl-box-item"><b>Lay</b></div>
          </div>
        </div>
        <div className="casino-box-row">
          <div className="casino-nation-name">
            <b>Main</b>
            <RangeInfo book={bookOf(exposures, 'Player B', 2)} rangeId="range7" min={playerB?.min} max={playerB?.max} />
          </div>
          <div className="casino-bl-box">
            <div
              className={`back casino-bl-box-item${suspCls(playerB)}`}
              onClick={isSusp(playerB) ? undefined : () => onBet(playerB.sid, 'back', playerB.b, playerB)}
            >
              <span className="casino-box-odd">{playerB?.b || 0}</span>
            </div>
            <div
              className={`lay casino-bl-box-item${suspCls(playerB)}`}
              onClick={isSusp(playerB) ? undefined : () => onBet(playerB.sid, 'lay', playerB.l, playerB)}
            >
              <span className="casino-box-odd">{playerB?.l || 0}</span>
            </div>
          </div>
        </div>
      </div>

      {/* Under/Over section */}
      <div className="teen2uo">
        <div className="teen1dayleft"></div>
        <div className="teen1daycenter"></div>
        <div className="teen1dayright">
          <div className="casino-box-row d-none-big">
            <div className="casino-nation-name no-border casino-bl-box-title">
              <div className="playerb">Player B</div>
            </div>
            <div className="casino-bl-box casino-bl-box-title"></div>
          </div>
          <div className="casino-box-row">
            <div className="casino-nation-name"><b>Player B Under 21</b> <RangeInfo book={bookOf(exposures, 'Player B Under 21', 3)} rangeId="range5" min={under21?.min} max={under21?.max} plain /></div>
            <div className="casino-bl-box">
              <div
                className={`back casino-bl-box-item${suspCls(under21)}`}
                onClick={isSusp(under21) ? undefined : () => onBet(under21.sid, 'back', under21.b, under21)}
              >
                <span className="casino-box-odd">{under21?.b || 0}</span>
              </div>
            </div>
            <div className="casino-nation-name"><b>Player B Over 21</b> <RangeInfo book={bookOf(exposures, 'Player B Over 21', 4)} rangeId="range6" min={over21?.min} max={over21?.max} plain /></div>
            <div className="casino-bl-box">
              <div
                className={`back casino-bl-box-item${suspCls(over21)}`}
                onClick={isSusp(over21) ? undefined : () => onBet(over21.sid, 'back', over21.b, over21)}
              >
                <span className="casino-box-odd">{over21?.b || 0}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

// ─── Mobile layout (d-none-big) ──────────────────────────────────────────────

const MobileLayout = memo(function MobileLayout({ sub, onBet, exposures }) {
  const playerA = findBySid(sub, 1);
  const playerB = findBySid(sub, 2);
  const [openRange, setOpenRange] = useState(false);

  const bookA = bookOf(exposures, 'Player A', 1);
  const bookB = bookOf(exposures, 'Player B', 2);

  // reference mobile: sirf Main market (Player A/B back+lay). Under/Over
  // section NAHI (wo desktop-only). Main title me range-info collapse.
  const playerRow = (label, item, book) => (
    <div className="casino-bl-box">
      <div className="casino-bl-box-item casino-odds-name">
        <span>{label}</span>
        {' '}
        <span className={`float-right ${bookCls(book)}`}>{fmtBook(book)}</span>
      </div>
      <div
        className={`back casino-bl-box-item${suspCls(item)}`}
        onClick={isSusp(item) ? undefined : () => onBet(item.sid, 'back', item.b, item)}
      >
        <span className="casino-box-odd">{item?.b || 0}</span>
      </div>
      <div
        className={`lay casino-bl-box-item${suspCls(item)}`}
        onClick={isSusp(item) ? undefined : () => onBet(item.sid, 'lay', item.l, item)}
      >
        <span className="casino-box-odd">{item?.l || 0}</span>
      </div>
    </div>
  );

  return (
    <div className="teen1daycasino-container d-none-big">
      <div className="casino-box-row">
        <div className="casino-bl-box casino-bl-box-title">
          <div className="casino-bl-box-item">
            <b>Main</b>
            {' '}
            <div className="float-right">
              <i
                data-toggle="collapse"
                data-target="#range1"
                className="fas fa-info-circle float-right"
                onClick={() => setOpenRange((o) => !o)}
              ></i>
              {' '}
              <Collapse id="range1" open={openRange} className="icon-range">
                {'\n                          R:'}
                <span>{fmtAmt(playerA?.min ?? playerB?.min)}</span>
                -
                <span>{fmtAmt(playerA?.max ?? playerB?.max)}</span>
              </Collapse>
            </div>
          </div>
          <div className="casino-bl-box-item"><b>Back</b></div>
          <div className="casino-bl-box-item"><b>Lay</b></div>
        </div>
        {playerRow('Player A', playerA, bookA)}
        {playerRow('Player B', playerB, bookB)}
      </div>
    </div>
  );
});

// ─── Main export ─────────────────────────────────────────────────────────────

const BetTableTeen41 = memo(function BetTableTeen41({ gameData, onBet, exposures }) {
  const sub = gameData?.sub || [];
  const handleBet = onBet || (() => {});

  return (
    <>
      <DesktopLayout sub={sub} onBet={handleBet} exposures={exposures} />
      <MobileLayout sub={sub} onBet={handleBet} exposures={exposures} />
    </>
  );
});

export default BetTableTeen41;
